import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const getContactsByCustomerId = async (customerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/customers/${customerId}/contacts`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const addContact = async (customerId, contact) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_URL}/customers/${customerId}/contacts`, contact, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateContact = async (contactId, contact) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_URL}/contacts/${contactId}`, contact, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteContact = async (contactId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_URL}/contacts/${contactId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
